import { useQuery } from "react-query";
import { GET_WINNING_BANNER } from "../appConstants/APIEndpoint";
import { requestApiPost } from ".";

const getWinningBannerApi = async (payloadData: any) => {
  const { gameName = "ludonx", ltid, OffsetToken } = payloadData;
  const payload = {
    gameName,
    ltid,
    OffsetToken,
  };
  try {
    const res = await requestApiPost(GET_WINNING_BANNER, payload);
    const response = res?.response;
    if (response?.success) {
      return response;
    } else {
      console.log("Failed to get Winning Banner API", response?.error);
    }
  } catch (error) {
    console.error("Error fetching winning banner:", error);
  }
};

export const useWinningBannerApi = (payloadData: any) => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ["winningBannerApi", payloadData],
    queryFn: () => getWinningBannerApi(payloadData),
    retry: false,
    // refetchOnWindowFocus: false,
    enabled: Boolean(payloadData),
  });

  return {
    winningBannerData: data,
    isLoading,
    error,
    refetch,
  };
};
